export default __webpack_public_path__ + "00afe5376fb55c309e284504dedbf053.png";